angular.module("eCareVault.common.itemCard", []);
